<template>
    <div>
        <h1>Ether</h1>
        <p>
            Ether sind zwei Alkyl-Reste, verbunden durch ein Sauerstoff-Atom.
        </p>
        <img
            src="@/assets/img/stoffe/ether/allgemeine-struktur.png"
            width="256px"
            height="auto"
            alt="Allgemeine Struktur der Ether"
            title="Allgemeine Struktur der Ether"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Verwendung"></chapter-heading>
        <ul>
            <li>Monosaccharide</li>
            <li>Einzelne Aromastoffe (z.B. Anisol, Vanilin)</li>
        </ul>
        <hr class="chapter-split" />
        <chapter-heading
            title="Beispiel einer Strukturformel"
        ></chapter-heading>
        <img
            src="@/assets/img/stoffe/ether/beispiel.svg"
            width="256px"
            height="auto"
            alt="Beispielhafte Strukturformel: H3C–O–CH–(CH3)2  [2-Methoxypropan oder Isopropylmethylether]"
            title="Beispielhafte Strukturformel: H3C–O–CH–(CH3)2  [2-Methoxypropan oder Isopropylmethylether]"
        />
        <hr class="chapter-split" />
        <chapter-heading title="Zusammenfassung"></chapter-heading>
        <table>
            <tr>
                <th>Beschreibung</th>
                <td>
                    <ul>
                        <li>bestehen aus zwei Alkoholen</li>
                        <li>
                            enstehen durch die Abspaltung von Wasser =>
                            Kondensation
                        </li>
                    </ul>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
import ChapterHeading from '../../components/chapterHeading';
export default {
    components: { ChapterHeading },
};
</script>
